import "core-js/modules/es6.object.assign";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { MenuDividerRoot as Root } from "./styled";
import { menuDividerPropTypes } from "./propTypes";

var MenuDivider = function MenuDivider(props) {
  return ___EmotionJSX(Root, _extends({}, props, {
    role: "separator"
  }));
};

MenuDivider.displayName = 'MenuDivider';
MenuDivider.propTypes = process.env.NODE_ENV !== "production" ? menuDividerPropTypes : {};
export default MenuDivider;